import { BusinessObjectBase } from './base';
import { loginSessionSchema } from '@schemas/business-objects/login-session';
import type { RegistryToken } from './registry-token';
import type { User } from './user';
import type { Id, LoginSessionStatus } from '../base-types';

export interface LoginSessionData {
  readonly id: Id;
  readonly sessionIdHash?: string;
  readonly status?: LoginSessionStatus;
  readonly requestedLabel?: string;
  readonly requestedCanPublish?: boolean;
  readonly expiresAt?: Date;
  readonly userId: Id;
  readonly user?: User;
  readonly tokenId: Id;
  readonly token?: RegistryToken;
}

export interface LoginSession extends Readonly<LoginSessionData> {}
export class LoginSession extends BusinessObjectBase {
  static readonly entityName = 'LoginSession' as const;
  static readonly plural = 'login-sessions';
  static schema = loginSessionSchema;

  // --- Static CRUD methods ---

  static async find(_filter?: any): Promise<LoginSession[]> {
    throw new Error('find is not available on LoginSession');
  }

  static async findOne(_filter?: any): Promise<LoginSession | null> {
    throw new Error('findOne is not available on LoginSession');
  }

  static async findById(_id: Id, _filter?: any): Promise<LoginSession> {
    throw new Error('findById is not available on LoginSession');
  }

  static async create(_data: any): Promise<LoginSession> {
    throw new Error('create is not available on LoginSession');
  }

  static async createMany(_data: any[]): Promise<LoginSession[]> {
    throw new Error('createMany is not available on LoginSession');
  }

  static async createWithChildren(_data: any): Promise<LoginSession> {
    throw new Error('createWithChildren is not available on LoginSession');
  }

  static async createManyWithChildren(_data: any[]): Promise<LoginSession[]> {
    throw new Error('createManyWithChildren is not available on LoginSession');
  }

  static async updateById(_id: Id, _updates: any): Promise<LoginSession> {
    throw new Error('updateById is not available on LoginSession');
  }

  static async deleteById(_id: Id): Promise<boolean> {
    throw new Error('deleteById is not available on LoginSession');
  }
}
